import { getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNumber',
  standalone: true,
})
export class ShortNumberPipe implements PipeTransform {
  /**
   * Makes short currncy view
   * @param value Number to be transformed
   * @param digits Number of digits after the decimal point. Must be in the range 0 - 20
   * @param currencyCode Char symbol to show before shorted result
   */
  transform(value: number, digits = 1, currencyCode = ''): string {
    const lookup = [
      { value: 1, symbol: '' },
      { value: 1e3, symbol: 'k' },
      { value: 1e6, symbol: 'M' },
      { value: 1e9, symbol: 'B' },
      { value: 1e12, symbol: 'T' },
      { value: 1e15, symbol: 'P' },
      { value: 1e18, symbol: 'E' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    let item = lookup
      .slice()
      .reverse()
      .find(i => {
        return value >= i.value;
      });
    if (item && (value / item.value).toFixed(digits).length - digits - 1 > 3) {
      item = lookup[lookup.indexOf(item) + 1];
    }
    return item
      ? getCurrencySymbol(currencyCode, 'narrow') +
          (value / item.value).toFixed(digits).replace(rx, '$1') +
          item.symbol
      : '0';
  }
}
